export default [
  {
    titleKey: "register.title",
    items: [
      {
        titleKey: "register.maintenance.title",
        path: "/register/maintenancelist",
        icon: "repeat",
        requiredPermission: "MaintenanceList"
      },
      {
        titleKey: "register.call.title",
        path: "/register/calllist",
        icon: "tel",
        requiredPermission: "CallList"
      },
      {
        titleKey: "register.serviceAct.title",
        path: "/register/serviceactlist",
        icon: "textdocument",
        requiredPermission: "ServiceActList"
      },
      {
        titleKey: "register.equipment.title",
        path: "/register/equipmentlist",
        icon: "product",
        requiredPermission: "EquipmentList"
      },
      {
        titleKey: "register.component.title",
        path: "/register/componentlist",
        icon: "box",
        requiredPermission: "EquipmentList"
      }
    ]
  },
  {
    titleKey: "classifier.title",
    items: [
      {
        titleKey: "classifier.equipmentmodel.title",
        path: "/classifier/equipmentmodellist",
        icon: "print",
        requiredPermission: "EquipmentModelList"
      },
      {
        titleKey: "classifier.equipmenttype.title",
        path: "/classifier/equipmenttypelist",
        icon: "detailslayout",
        requiredPermission: "EquipmentTypeList"
      },
      {
        titleKey: "classifier.equipmentcategory.title",
        path: "/classifier/equipmentcategorylist",
        icon: "detailslayout",
        requiredPermission: "EquipmentCategoryList"
      },
      {
        titleKey: "classifier.manufacturer.title",
        path: "/classifier/manufacturerlist",
        icon: "optionsgear",
        requiredPermission: "ManufacturerList"
      },
      {
        titleKey: "classifier.client.title",
        path: "/classifier/clientlist",
        icon: "group",
        requiredPermission: "ClientList"
      },
      {
        titleKey: "classifier.enduser.title",
        path: "/classifier/enduserlist",
        icon: "card",
        requiredPermission: "EndUserList"
      },
      {
        titleKey: "classifier.profession.title",
        path: "/classifier/professionlist",
        icon: "car",
        requiredPermission: "ProfessionList"
      },
      {
        titleKey: "classifier.person.title",
        path: "/classifier/personlist",
        icon: "user",
        requiredPermission: "PersonList"
      },
    ]
  },
  {
    titleKey: "administration.title",
    items: [
      {
        titleKey: "administration.administration.title",
        path: "/administration/administration",
        icon: "preferences",
        requiredPermission: "Administration"
      },
      {
        titleKey: "administration.printForm.title",
        path: "/administration/printformlist",
        icon: "print",
        requiredPermission: "PrintFormList"
      },
      /*
      {
        titleKey: "administration.report.title",
        path: "/administration/reportlist",
        icon: "chart",
        requiredPermission: "ReportList"
      },*/
    ]
  },
];
